function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 3823.86,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M13222 44768c-1584,0 -2868,-1284 -2868,-2868l0 -28677c0,-1584 1284,-2868 2868,-2868l28677 0c1584,0 2868,1284 2868,2868m-21985 5736l26765 0c2114,0 3826,1711 3826,3823l-2 26766c2,2111 -1710,3823 -3822,3823l-26767 1c-2111,-1 -3823,-1713 -3823,-3825l-1 -26764c1,-2113 1713,-3824 3825,-3824z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 63727 63727",
    className: "icon",
    style: {
      "height": "1em",
      "width": "1em"
    }
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/copy.aee25c59.svg";
export { SvgComponent as ReactComponent };